import React from 'react';
import type { CustomCellRendererProps } from 'ag-grid-react';
import { styles } from './FilterCellRenderer.styles';
import { Box, Typography } from '@mui/material';

type FilterValue = string | undefined;

type FilterCellRendererProps = CustomCellRendererProps<unknown, FilterValue> & {
  valuesWithCounts: [string, string][];
};

export function FilterCellRenderer({ valuesWithCounts, ...props }: FilterCellRendererProps) {
  let value = '';
  let count = '';

  if (!props.value) {
    value = '(Blanks)';
  } else if (props.value === '(Select All)') {
    value = props.value;
  } else {
    const found = valuesWithCounts.find(([v]) => v === props.value);
    if (found) {
      [value, count] = found;
    } else {
      value = props.value;
    }
  }

  return (
    <Box sx={styles.container}>
      <Typography noWrap component="span">
        {value}
      </Typography>
      {count ? (
        <Typography sx={styles.count} variant="bodySmall" component="span">
          ({count})
        </Typography>
      ) : null}
    </Box>
  );
}
